import { FEATURE } from '@/core/features/featureCodes';
import { withModuleScopedMasterRoutes } from '@/config/moduleSharedPaths';

const BASE_ORG_ROUTE_FEATURES: Record<string, string | string[] | null> = {
  '/pos/dashboard': FEATURE.REPORTING,
  '/org/profile': null,
  '/pos/stores': null,
  '/org/employees': FEATURE.EMPLOYEE_BASIC,
  '/org/roles': FEATURE.EMPLOYEE_BASIC,
  '/pos/products': FEATURE.POS_BILLING,
  '/pos/categories': FEATURE.POS_BILLING,
  '/pos/brands': FEATURE.POS_BILLING,
  '/pos/units': FEATURE.POS_BILLING,
  '/pos/taxes': FEATURE.POS_BILLING,
  '/pos/tax-rules': FEATURE.POS_BILLING,
  '/pos/store-products': FEATURE.POS_BILLING,
  '/pos/invoices': FEATURE.POS_BILLING,
  '/pos/inventory': FEATURE.INVENTORY,
  '/pos/inventory/ledger': FEATURE.INVENTORY,
  '/warehouse': FEATURE.WAREHOUSE,
  '/warehouse/operations': FEATURE.WAREHOUSE,
  '/warehouse/mobile': FEATURE.WAREHOUSE,
  '/warehouse/setup': FEATURE.WAREHOUSE,
  '/warehouse/picks': FEATURE.WAREHOUSE,
  '/warehouse/transfers': FEATURE.WAREHOUSE,
  '/warehouse/cycle-counts': FEATURE.WAREHOUSE,
  '/warehouse/waves': FEATURE.WAREHOUSE,
  '/warehouse/dock': FEATURE.WAREHOUSE,
  '/warehouse/cross-dock': FEATURE.WAREHOUSE,
  '/warehouse/labor': FEATURE.WAREHOUSE,
  '/pos/product-alerts': FEATURE.INVENTORY,
  '/pos/suppliers': FEATURE.PROCUREMENT,
  '/procurement': FEATURE.PROCUREMENT_BASIC,
  '/procurement/purchase-requests': FEATURE.PROCUREMENT_BASIC,
  '/procurement/rfqs': FEATURE.PROCUREMENT_RFQ,
  '/procurement/quotations': FEATURE.PROCUREMENT_RFQ,
  '/procurement/purchase-orders': FEATURE.PROCUREMENT_BASIC,
  '/procurement/goods-receipts': FEATURE.PROCUREMENT_BASIC,
  '/procurement/vendor-bills': FEATURE.PROCUREMENT_BASIC,
  '/procurement/approvals': FEATURE.PROCUREMENT_APPROVALS,
  '/procurement/reports': FEATURE.PROCUREMENT_ADVANCED_ANALYTICS,
  '/procurement/setup': FEATURE.PROCUREMENT_APPROVALS,
  '/procurement/contracts': FEATURE.PROCUREMENT_CONTRACTS,
  '/procurement/catalogs': FEATURE.PROCUREMENT_CATALOG,
  '/pos/customers': FEATURE.CRM_BASIC,
  '/crm': FEATURE.CRM_BASIC,
  '/crm/leads': FEATURE.CRM_BASIC,
  '/crm/contacts': FEATURE.CRM_BASIC,
  '/crm/companies': FEATURE.CRM_BASIC,
  '/crm/deals': FEATURE.CRM_BASIC,
  '/crm/pipelines': FEATURE.CRM_PIPELINE,
  '/crm/followups': FEATURE.CRM_BASIC,
  '/crm/tasks': FEATURE.CRM_BASIC,
  '/crm/campaigns': FEATURE.CRM_CAMPAIGNS,
  '/crm/analytics': FEATURE.CRM_ANALYTICS,
  '/crm/reports': FEATURE.CRM_ANALYTICS,
  '/crm/setup': FEATURE.CRM_BASIC,
  '/work': null,
  '/work/executive': null,
  '/notifications': null,
  '/social': FEATURE.SOCIAL_BASIC,
  '/social/inbox': FEATURE.SOCIAL_INBOX,
  '/social/channels': FEATURE.SOCIAL_BASIC,
  '/social/publishing': FEATURE.SOCIAL_PUBLISHING,
  '/social/approvals': FEATURE.SOCIAL_APPROVALS,
  '/social/webhooks': FEATURE.SOCIAL_BASIC,
  '/social/calendar': FEATURE.SOCIAL_CALENDAR,
  '/social/media': FEATURE.SOCIAL_PUBLISHING,
  '/social/analytics': FEATURE.SOCIAL_ANALYTICS,
  '/social/automation': FEATURE.SOCIAL_AUTOMATION,
  '/social/crm-leads': FEATURE.SOCIAL_BASIC,
  '/social/teams': FEATURE.SOCIAL_BASIC,
  '/social/comments': FEATURE.SOCIAL_INBOX,
  '/social/connect': FEATURE.SOCIAL_BASIC,
  '/social/connect/wizard': FEATURE.SOCIAL_BASIC,
  '/social/connect/guide': FEATURE.SOCIAL_BASIC,
  '/social/settings': FEATURE.SOCIAL_BASIC,
  '/social/platforms': FEATURE.SOCIAL_BASIC,
  '/social/listening': FEATURE.SOCIAL_LISTENING,
  '/social/campaigns': FEATURE.SOCIAL_CAMPAIGNS,
  '/social/reviews': FEATURE.SOCIAL_REPUTATION,
  '/social/reports': FEATURE.SOCIAL_ANALYTICS,
  '/social/setup': FEATURE.SOCIAL_BASIC,
  '/hr': FEATURE.HR_BASIC,
  '/hr/employees': FEATURE.HR_BASIC,
  '/hr/attendance': FEATURE.HR_ATTENDANCE,
  '/hr/leaves': FEATURE.HR_BASIC,
  '/hr/approvals': FEATURE.HR_BASIC,
  '/hr/payroll': FEATURE.HR_PAYROLL,
  '/hr/recruitment': FEATURE.HR_RECRUITMENT,
  '/hr/appraisal': FEATURE.HR_APPRAISAL,
  '/hr/claims': FEATURE.HR_CLAIMS,
  '/hr/training': FEATURE.HR_BASIC,
  '/hr/reports': FEATURE.HR_ANALYTICS,
  '/hr/setup': FEATURE.HR_BASIC,
  '/hr/statutory': FEATURE.HR_PAYROLL,
  '/hr/ess': FEATURE.HR_BASIC,
  '/hr/feedback360': FEATURE.HR_APPRAISAL,
  '/hr/devices': FEATURE.HR_ATTENDANCE,
  '/desk': FEATURE.DESK_BASIC,
  '/desk/tickets': FEATURE.DESK_BASIC,
  '/desk/support-360': FEATURE.DESK_CUSTOMER_360,
  '/desk/inbox': FEATURE.DESK_BASIC,
  '/desk/livechat': FEATURE.DESK_LIVE_CHAT,
  '/desk/projects': FEATURE.DESK_PROJECTS,
  '/desk/boards': FEATURE.DESK_PROJECTS,
  '/desk/knowledgebase': FEATURE.DESK_BASIC,
  '/desk/reports': FEATURE.DESK_ANALYTICS,
  '/desk/automation': FEATURE.DESK_AUTOMATION,
  '/desk/setup': FEATURE.DESK_BASIC,
  '/desk/setup/workflows': FEATURE.DESK_BASIC,
  '/desk/canned-responses': FEATURE.DESK_BASIC,
  '/finance': FEATURE.FINANCE_BASIC,
  '/finance/receivables': FEATURE.FINANCE_BASIC,
  '/finance/payables': FEATURE.FINANCE_BASIC,
  '/finance/payables/ap': FEATURE.FINANCE_BASIC,
  '/finance/tax': FEATURE.FINANCE_BASIC,
  '/finance/control': FEATURE.FINANCE_BASIC,
  '/finance/setup/wizard': FEATURE.FINANCE_BASIC,
  '/finance/health': FEATURE.FINANCE_BASIC,
  '/finance/close': FEATURE.FINANCE_ACCOUNTING,
  '/finance/control/rules': FEATURE.FINANCE_ACCOUNTING,
  '/finance/treasury/forecast': FEATURE.FINANCE_BASIC,
  '/finance/collections': FEATURE.FINANCE_BASIC,
  '/finance/automation': FEATURE.FINANCE_ACCOUNTING,
  '/finance/analytics': FEATURE.FINANCE_ADVANCED_REPORTS,
  '/finance/compliance': FEATURE.FINANCE_BASIC,
  '/finance/audit': FEATURE.FINANCE_ACCOUNTING,
  '/finance/documents': FEATURE.FINANCE_BASIC,
  '/finance/integrations': FEATURE.FINANCE_BASIC,
  '/finance/accounting': FEATURE.FINANCE_ACCOUNTING,
  '/finance/ledger': FEATURE.FINANCE_ACCOUNTING,
  '/finance/invoices': FEATURE.FINANCE_BASIC,
  '/finance/payments': FEATURE.FINANCE_BASIC,
  '/finance/banking': FEATURE.FINANCE_BASIC,
  '/finance/taxes': FEATURE.FINANCE_BASIC,
  '/finance/expenses': FEATURE.FINANCE_BASIC,
  '/finance/assets': FEATURE.FINANCE_ASSETS,
  '/finance/budgets': FEATURE.FINANCE_BUDGETING,
  '/finance/treasury': FEATURE.FINANCE_BASIC,
  '/finance/revenue': FEATURE.FINANCE_ACCOUNTING,
  '/finance/workflows': FEATURE.FINANCE_ACCOUNTING,
  '/finance/workflows/designer': FEATURE.FINANCE_ACCOUNTING,
  '/finance/reports': FEATURE.FINANCE_ADVANCED_REPORTS,
  '/finance/reports/builder': FEATURE.FINANCE_ADVANCED_REPORTS,
  '/finance/setup': FEATURE.FINANCE_BASIC,
  '/projects': FEATURE.PROJECTS_BASIC,
  '/projects/list': FEATURE.PROJECTS_BASIC,
  '/projects/tasks': FEATURE.PROJECTS_BASIC,
  '/projects/boards': FEATURE.PROJECTS_BASIC,
  '/projects/sprints': FEATURE.PROJECTS_SPRINTS,
  '/projects/timesheets': FEATURE.PROJECTS_TIMESHEETS,
  '/projects/portfolio': FEATURE.PROJECTS_PORTFOLIO,
  '/projects/issues': FEATURE.PROJECTS_BASIC,
  '/projects/gantt': FEATURE.PROJECTS_GANTT,
  '/projects/resources': FEATURE.PROJECTS_BASIC,
  '/projects/calendar': FEATURE.PROJECTS_BASIC,
  '/projects/workload': FEATURE.PROJECTS_ADVANCED_ANALYTICS,
  '/projects/reports': FEATURE.PROJECTS_ADVANCED_ANALYTICS,
  '/projects/automation': FEATURE.PROJECTS_AUTOMATION,
  '/projects/setup': FEATURE.PROJECTS_BASIC,
  '/pos/discounts': FEATURE.POS_BILLING,
  '/pos/reports': FEATURE.REPORTING,
  '/org/subscription': null,
  '/org/administration/billing': null,
  '/org/settings': null,
  '/org/administration': null,
};

/** Org routes gated by subscription features */
export const ORG_ROUTE_FEATURES = withModuleScopedMasterRoutes(BASE_ORG_ROUTE_FEATURES);

export const POS_ROUTE_FEATURES: Record<string, string | string[] | null> = {
  '/pos/dashboard': FEATURE.REPORTING,
  '/pos': FEATURE.POS_BILLING,
  '/pos/held': FEATURE.POS_BILLING,
  '/pos/shift': FEATURE.POS_SHIFT_MANAGEMENT,
  '/pos/returns': FEATURE.POS_RETURNS,
  '/pos/analytics': FEATURE.POS_ANALYTICS,
  '/pos/setup': FEATURE.POS_BILLING,
  '/pos/terminal-reports': FEATURE.POS_BILLING,
  '/pos/shortcuts': FEATURE.POS_BILLING,
};

